





















import Vue from "vue";
import { Utils } from "@/js/Utils";
import { EventLogger } from "@/js/EventLogger";

function hasColor(point: Array<number>): boolean {
  const [r, g, b, a] = point;
  return r !== 0 && g !== 0 && b !== 0 && a !== 0;
}

function isNoPermissionMessage(message: string): boolean {
  const noPermissionRegexes = [/Permission denied/i, /Permission dismissed/i, /The request is not allowed/i];
  return noPermissionRegexes.some(regex => regex.test(message));
}

function isInvalidConstraintsError(message: string): boolean {
  const invalidConstraintsRegexes = [/Invalid constraint/i];
  return invalidConstraintsRegexes.some(regex => regex.test(message));
}

export default Vue.extend({
  props: { strategy: String },
  data() {
    return {
      initWidth: 120,
      initHeight: 180,
      videoWidth: 0,
      videoHeight: 0,
      rawWidth: 0,
      rawHeight: 0,
      cssVars: {},
      shouldRotate: Utils.getConfigBooleanValue("FLIP_VIDEO")
    };
  },
  mounted: async function() {
    const constraints = this.getMediaStreamConstraintsByStrategy(this.strategy);
    const mediaStream = await this.requestCamera(constraints);
    if (!mediaStream) {
      return;
    }
    (window as any).testingStream = mediaStream;
    (this.$refs.videoElement as HTMLMediaElement).srcObject = mediaStream;
    const { videoWidth, videoHeight, rawWidth, rawHeight } = this.getMediaStreamInfoByStrategy(
      this.strategy,
      mediaStream
    );
    this.videoWidth = videoWidth;
    this.videoHeight = videoHeight;
    this.rawWidth = rawWidth;
    this.rawHeight = rawHeight;
    this.cssVars = {
      width: this.initWidth + "px",
      height: this.initHeight + "px"
    };
    if (Utils.getConfigBooleanValue("CAMERA_AUTO_SELECT_ENABLED")) {
      (this.$refs.videoElement as HTMLMediaElement).addEventListener("loadeddata", () => {
        setTimeout(() => {
          const checkResult = this.takeVideoScreenshotAndCheck4Corners();
          if (checkResult) {
            this.$emit("auto-confirm");
          } else {
            this.$emit("auto-reject");
          }
        }, 100);
      });
    }
  },
  beforeDestroy() {
    const currentStream = (this.$refs.videoElement as HTMLMediaElement).srcObject as MediaStream;
    if (!currentStream) return;
    Utils.closeCameraStream(currentStream);
  },
  methods: {
    async requestCamera(constraints: MediaStreamConstraints): Promise<MediaStream | null> {
      try {
        return await Utils.requestCameraAsync(constraints);
      } catch (e) {
        const errorMessage = e.message ? e.message : e.toString();
        EventLogger.singleton.sendCameraRequestErrorEvent(errorMessage);
        if (isNoPermissionMessage(errorMessage)) {
          this.$emit("no-permission");
        }
        if (isInvalidConstraintsError(errorMessage)) {
          this.$emit("auto-reject", true);
        }
        return null;
      }
    },
    getMediaStreamConstraintsByStrategy(strategy: string): MediaStreamConstraints {
      let width = this.initWidth;
      let height = this.initHeight;
      if (strategy.includes("SwapInit")) {
        [width, height] = [height, width];
      }
      const constraints: MediaStreamConstraints = {
        audio: false,
        video: {
          width,
          height,
          facingMode: "user"
        }
      };

      return constraints;
    },
    getMediaStreamInfoByStrategy(
      strategy: string,
      mediaStream: MediaStream
    ): { videoWidth: number; videoHeight: number; rawWidth: number; rawHeight: number } {
      let videoWidth = mediaStream.getVideoTracks()[0].getSettings().width || 0;
      let videoHeight = mediaStream.getVideoTracks()[0].getSettings().height || 0;
      const rawWidth = videoWidth;
      const rawHeight = videoHeight;
      if (strategy.includes("SwapResult")) {
        [videoWidth, videoHeight] = [videoHeight, videoWidth];
      }
      return {
        videoWidth,
        videoHeight,
        rawWidth,
        rawHeight
      };
    },
    takeVideoScreenshotAndCheck4Corners() {
      const video = this.$refs.videoElement as HTMLMediaElement;
      const canvas = this.$refs.theCanvas as any;
      canvas.width = this.initWidth;
      canvas.height = this.initHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0);
      const topRight = ctx.getImageData(110, 20, 1, 1).data;
      const botRight = ctx.getImageData(110, 150, 1, 1).data;
      return this.matchWithAllDimention && hasColor(topRight) && hasColor(botRight);
    }
  },
  computed: {
    matchWithAllDimention(): boolean {
      return this.initWidth === this.videoWidth && this.initHeight === this.videoHeight;
    }
  }
});
